import api from "./axios";
import { ConfirmOtpPayload, SendOtpParams } from "@/struct/AuthStruct";

export default class AuthService {
  sendOtp = (params: SendOtpParams) => {
    return api.get("/api/mobile/account/enter/send-otp", {
      params: {
        msisdn: params.msisdn,
      },
    });
  };
  confirmOtp = (payload: ConfirmOtpPayload) => {
    return api.post("/api/mobile/account/enter/confirm-otp", payload);
  };

  logout = () => {
    return api.get("/api/mobile/account/enter/logout");
  };
}
